// NPM imports
import React from "react";
import { Tooltip, NumberInput, Input } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Declarations
const NON_LINEAR = "non-linear";

// Component
export default function BundleRow(props) {
  const {
    currencySymbol = "$",
    type,
    data,
    deleteEntry,
    index,
    onChange,
  } = props;
  // Render Section
  return (
    <div className="bundlerow-wrapper">
      <div className="bundlerow-input-wrapper">
        <div className="bundlerow-input is-first">{data.sku}</div>
        <NumberInput
          className="is-disabled"
          disabled
          isCurrency
          inpCurrencySymbol={currencySymbol}
          readOnly
          value={data.price}
        />
        <NumberInput
          className="bundlerow-input is-last"
          isFloat
          onChange={value => onChange("months", index, value)}
          placeholder="Please enter a value."
          value={data.months}
          data-test="bundlerow-number-input"
        />
        <div
          className="bundlerow-delete"
          onKeyPress={() => deleteEntry(index)}
          role="button"
          tabIndex="0"
          onClick={() => deleteEntry(index)}>
          <Tooltip placement="top" overlay="Remove Product">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </Tooltip>
        </div>
      </div>
      {type === NON_LINEAR && (
        <div className="bundlerow-sku-include">
          <Input
            onChange={event =>
              onChange("multiplySku", index, event.target.checked)
            }
            type="checkbox"
            checked={data.multiplySku}
            data-test="bundlerow-input"
          />
          <span>Multiply the SKU Quantity with effort in Deal Table</span>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Pricebook/BundleRow/BundleRow.js